import { useNavigate } from "react-router-dom";

export const useNavigation = () => {
  const navigate = useNavigate();

  const toServices = () => {
    navigate("/services");
  };
  const toConsult = () => {
    navigate("/");
  };
  const toServicesId = (id) => {
    navigate(`/services/${id}`);
  };
  const toBlog = () => {
    navigate("/about/blog");
  };
  const toRatings = () => {
    navigate("/ratings");
  };
  const toPost = () => {
    navigate(`/about/blog/post:id`);
  };
  const toAbout = () => {
    navigate("/about/company");
  };
  const toPolicy = () => {
    navigate("/policy");
  };
  const toMain = () => {
    navigate("/");
  };
  const toServices1 = () => {
    navigate("/services/talkitout");
  };
  const toServices2 = () => {
    navigate("/services/careerconsulting");
  };
  const toServices3 = () => {
    navigate("/services/cvready");
  };
  const toServices4 = () => {
    navigate("/services/supportduringthejobsearchsupport");
  };
  const toServices5 = () => {
    navigate("/services/supportduringtheprobationaryperiod");
  };
  const toServices6 = () => {
    navigate("/services/recruitmentofITspecialists");
  };
  const toServices7 = () => {
    navigate("/services/trainingofITrecruiters");
  };
  const toServicesVS = () => {
    navigate("/services/vs");
  };

  return {
    toServices,
    toConsult,
    toServicesId,
    toBlog,
    toRatings,
    toAbout,
    toPolicy,
    toMain,
    toServices1,
    toServices2,
    toServices3,
    toServices4,
    toServices5,
    toServices6,
    toServices7,
    toServicesVS,
    toPost,
  };
};

export const goTo = (e) => {
  e.preventDefault();
  window.location.href = "https://t.me/ProhorovaConsult";
};
